import React, { Component } from 'react';
import { string, func, bool } from 'prop-types';

const SIZES = ['sm', 'md', 'lg']
const TYPES = ['flat', 'primary', 'secondary', 'danger']
const NAMES = ['cancel', 'submit']

const ACCEPTED_PROPERTIES = [...SIZES, ...TYPES, ...NAMES]

export default class Button extends Component {
  render() {
    const { onClick, disabled, className, children, type='button', ...other } = this.props
    let localClassName = className
    localClassName += Object.keys(other)
      .filter((key) => ACCEPTED_PROPERTIES.includes(key))
      .map(prop => ` btn-${prop}`)
      .join(' ')

    return (
      <button
        className={`btn ${localClassName}`}
        disabled={disabled}
        onClick={onClick}
        type={type}
      >
        {children}
      </button>
    )
  }
}

Button.propTypes = {
  disabled: bool,
  className: string,
  onClick: func
};

Button.defaultProps = {
  disabled: false,
  className: '',
  onClick: () => { }
};